import { Navigate } from 'react-router-dom';
import { useSession } from '../auth/session';
import ScanPrompt from './ScanPrompt';

/** Admins land straight in the admin panel; everyone else gets the scan screen. */
export default function HomeGate() {
  const session = useSession();
  if (session?.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }
  return <ScanPrompt />;
}
